import { getLink } from "../../../utils/utils";

const content = {
	esp: (
		`
		<p class="mb-3">
			Denove ekplaŭdis la delonge stagnanta lago (aŭ flako?) de la fama diskuto «ata-ita». 
			Denove sciuloj asertas, ke laŭ la «nura ĝusta verba aspekto» devas esti «ata», sed ne «ita».
		</p>
		
		<p class="mb-3">
			Sed ĉu vere en Esperanto ekzistas aspektoj de verboj? 
			Jes, certe, en PMEG kaj aliaj gramatikoj per pluraj frazoj sur multaj paĝoj estas klarigitaj aspektoj de verboj; same kiel en latinidaj kaj ĝermanaj lingvoj.
		</p>
		
		<p class="mb-3">
			Sed ĉu Esperanto estas latinida aŭ ĝermana lingvo?
		</p>
		
		<p class="mb-3">
			Ĝi estis kreita de d-ro Zamenhof speciale kiel INTERNACIA lingvo, ne apartenanta al iu nacio aŭ popolo. Ĝuste tia estas ĝia origina destino; kaj eĉ nomiĝis ĝi origine: «La Lingvo Internacia».
		</p>
		
		<p class="mb-3">
			En siaj unuaj provoj Zamenhof emis obei naciajn strukturojn de eŭropaj lingvoj; sed poste (kaj eble sur fono de Volapȕk kun terure komplika gramatiko) li konscie kreis la plej simplan lingvon, kiun eklerni estos facile por ajnalingvano.
		</p>
		
		<p class="mb-3">
			Tial, en Esperanto forestas 26 aspektoj de la verbo, sed ekzistas nur tri TEMPOJ: -as, -os, -is. 
			Tiuj tri tempoj tute klare kaj adekvate priskribas ajnan situacion; kaj la kompleksaj formoj (kun participo) ankaŭ estas klaraj, se percepti ilin de simpla, reala vidpunkto, sed ne de la gramatika, konvencia. 
			Tiel, se oni skribas, ke io estis trovITA en 1965, tio signifas nur: iam, dum iu momento en 1965 tio okazis; sed se ĝi estis trovATA en 1965 – do, dum ĉiuj 365 tagoj de tiu jaro io estis konstante trovata… trovata…, sed neniu signo pri la rezulto. 
			ATA – procezo, ITA – rezulto. 
			Tiel aspektas la afero por simpla prudenta uzanto, ne superŝutita per specialaj gramatikaj konvencioj. 
			Kaj ĝuste tiel devas esti en vere internacia lingvo, kiu donus «nenian privilegion» al ajna nacio. 
			Simpleco kaj klareco – jen la vojo por Esperanto. 
			Alia vojo kondukos ĝin al tombo. 
			Ĝi aperas nur pro memkompensemo de eŭropanoj, kiuj ne povas (aŭ ne volas) uzi la lingvon, strukturitan aliel ol ilia propra lingvo, kaj pro tio altrudas al ĝi tute fremdajn ecojn. 
			Nevane ja, la azianoj jam komencis diri, ke Esperanto estas eŭropa lingvo, sed ne vere internacia.
		</p>
		
		<p class="mb-3">
			Nu, daŭrigu la procezon «pliriĉigi» la lingvon per abundaj neologismoj, «science prilaboru» la gramatikon per «verbaj aspektoj» kaj «tensoj» – kaj vi ricevos Esperanton, tute taŭgan por vi, komfortan kiel via propra lingvo. 
			Vi sentos vin en ĝi «gemute»; kaj ĉu pensi pri iuj azianoj aŭ afrikanoj? Esperanto estas eŭropa lingvo, kaj por ni tio tute sufiĉas, por kio la foraj kontinentoj?» – vi diros.
		</p>
		
		<p class="mb-5">
			Tiel Esperanto vere perdas sian solan celon: esti INTERnacia komprenilo. 
			Kaj la kaŭzo estas eĉ ne nur eŭropa sinadoro kaj tromemtakso, sed ankaŭ tute mala: ĝia perdo de vivoforto. 
			Eŭropanoj fariĝis tro pigraj por eluzi la lingvon en ĝiaj senlimaj eblecoj, konstruante novajn vortojn kaj kreante novajn signifojn; ili simple, sed troa peno, «importas» la vortojn el siaj naciaj lingvoj. 
			Ili ne zorgas, ke ilia frazo estu eleganta kaj komprenebla; ne, ili ŝtopas ĝin per ŝtuparoj de «verbaj aspektoj» – simple, ĉar tiel oni diras en ilia propra lingvo.
		</p>
		
		<p class="mb-5">
			Ĉu iu aŭdis pri neologismoj, prenitaj el la ĉina aŭ la japana? 
			Ĉu gramatikojn verkas aŭ almenaŭ kompletigas azianoj? 
			Ĉu ne drivas Esperanto tiamaniere al la vojo, kiu peregos ĝin, farinte nur «intereŭropa» lingvo», fakte, tute nebezonata, ĉar eŭropanoj ĉiam trovos por interkompreniĝo iun nacian lingvon – jen germanan, jen francan, jen anglan… Kaj fakte, por ili Esperanto eĉ nun ne estas bezonata…
		</p>
		
		<p class="mb-3">
			Ankoraŭ unu konvencio: la uzo de –as post se. 
			Ankaŭ sub la influo de romanaj kaj ĝermanaj lingvoj, esperantistoj timas aŭ evitas uzi post se futuron, kvankam por natura, netordita per gramatiko orelo, la diferenco inter esprimoj estas evidenta:
		</p>
		
		<p class="mb-3">
			Se vi mortigos homon, oni punos vin – Nenio ankraŭ okazis, ĉio en supozoj.
		</p>
		
		<p class="mb-3">
			Se vi mortigas homon, oni punos vin – Vi estas en procezo de mortigado. Haltu!
		</p>
		
		<p class="mb-5">
			Se vi mortigis homon, oni punos vin – Se tio jam okazis, nenio helpos al vi.
		</p>

		<p class="mb-3">
			Tiel klaraj estas la ekzempoj; sed ĉu klareco nun estas laŭmoda?
		</p>
		`
	)
}

const itemName = {
	esp: 'Iom pri la gramatiko de Esperanto'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp:{
		itemName: itemName.esp,
		itemContent: content.esp
	}
}

export default item;